<!-- @format -->

<template>
  <div id="organisation-profile">
    <div class="content-wrapper">
      <div class="col-md-12">
        <div class="card" style="padding:0px; padding-bottom:15px;">
          <div class="profile-cover">
            <a style="cursor:inherit">
              <el-upload
                class="avatar-uploader"
                :action="$client.defaults.baseURL + 'event/uploadImage?uploadType=organizationCover&language=' + $i18n.locale"
                :headers="{
                  Authorization: $client.defaults.headers['Authorization']
                }"
                :show-file-list="false"
                :on-success="coverSuccess"
              >
                <div class="el-upload__tip" slot="tip">{{ $t("eventInfo.cover.description") }}</div>
                <el-button slot="trigger" size="small" type="primary" circle icon="el-icon-upload"></el-button>
              </el-upload>
            </a>
            <div class="profile-cover-img" :key="currentOrganization.cover" :style="'border-radius: 16px 16px 0px 0px; background: #ececec; background-image: url(' + $imageus + currentOrganization.cover + '?width=1120&height=500&mode=cover' + '); background-position: center; background-size: cover;'"></div>
          </div>

          <div class="custom-profile-bar media align-items-center text-center text-md-left flex-column flex-md-row m-0">
            <div class="mr-md-3 mb-2 mb-md-0">
              <div class="profile-thumb">
                <el-tooltip class="item" effect="dark" :content="$t('organisation.profile.updateMax')" placement="top">
                  <a style="cursor:inherit">
                    <el-upload
                      class="avatar-uploader upload-logo"
                      :action="$client.defaults.baseURL + 'event/uploadImage?uploadType=organizationLogo&language=' + $i18n.locale"
                      :headers="{
                        Authorization: $client.defaults.headers['Authorization']
                      }"
                      :show-file-list="false"
                      :on-success="logoSuccess"
                    >
                      <el-button size="small" type="primary" circle icon="el-icon-upload"></el-button>
                      <div class="el-upload__tip" slot="tip">{{ $t("eventInfo.logo.description") }}</div>
                    </el-upload>
                  </a>
                </el-tooltip>

                <img :src="$imageus + currentOrganization.image + '?width=200&height=200&mode=contain'" style="background: #ececec; cursor: default" class="border-white" width="120" height="120" alt />
              </div>
            </div>

            <div class="media-body custom-media-text">
              <h1 class="mb-0">{{ currentOrganization.title }}</h1>
              <span style="margin-top:3px;">{{ currentOrganization.about }}</span>
            </div>
          </div>

          <div class="org-profile-container">
            <el-form ref="form" label-width="250px" size="mini">
              <el-form-item :label="$t('organisation.profile.organisationName')">
                <el-input size="medium" show-word-limit maxlength="120" :class="{ error: validInput('title', validation) }" v-model="currentOrganization.title"></el-input>
              </el-form-item>
              <el-form-item :label="$t('organisation.profile.about')">
                <el-input size="medium" show-word-limit maxlength="600" :class="{ error: validInput('about', validation) }" v-model="currentOrganization.about"></el-input>
              </el-form-item>
              <el-form-item :label="$t('organisation.profile.organizasyonType')">
                <el-select v-model="currentOrganization.categoryIds" multiple size="medium">
                  <el-option v-for="category in organizationCategories" :key="category.id + '-categoryId'" :label="category.title" :value="category.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('organisation.profile.email')">
                <el-input size="medium" v-model="currentOrganization.email" :class="{ error: validInput('email', validation) }"><i class="fas fa-pen el-input__icon" slot="suffix"></i></el-input>
              </el-form-item>
              <el-form-item :label="$t('organisation.profile.mobile')">
                <el-input size="medium" v-model="currentOrganization.mobile" :class="{ error: validInput('mobile', validation) }"><i class="el-icon-phone el-input__icon" slot="suffix"></i></el-input>
              </el-form-item>
              <el-form-item :label="$t('organisation.profile.phone')">
                <el-input size="medium" v-model="currentOrganization.phone" :class="{ error: validInput('phone', validation) }"><i class="el-icon-phone el-input__icon" slot="suffix"></i></el-input>
              </el-form-item>

              <hr />
              <template v-if="currentOrganization.location">
                <el-form-item :label="$t('contentManagement.stands.standAddUpdate.contact.addressHeader')">
                  <el-input @change="venueChanged = true" size="medium" v-model="currentOrganization.location.venue" :class="{ error: validInput('location.Venue', validation) }"></el-input>
                </el-form-item>
                <el-form-item :label="$t('organisation.profile.address')">
                  <el-input size="medium" show-word-limit maxlength="300" v-model="currentOrganization.location.address" :class="{ error: validInput('location.Address', validation) }"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contentManagement.stands.standAddUpdate.contact.country')">
                  <el-input v-model="currentOrganization.location.country" size="medium" :class="{ error: validInput('location.City', validation) }"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contentManagement.stands.standAddUpdate.contact.city')">
                  <el-input v-model="currentOrganization.location.city" size="medium" :class="{ error: validInput('location.Country', validation) }"></el-input>
                </el-form-item>

                <el-form-item :label="$t('contentManagement.stands.standAddUpdate.contact.chooseLocation')">
                  <div class="position-relative w-100 completed-area">
                    <gmap-autocomplete class="introInput mb-2" :class="$inputError('location.Latitude', validation)" @place_changed="placeChanged" :placeholder="$t('event.textbox.search')">
                      <template v-slot:input="slotProps">
                        <v-text-field style="width: 100%" id="addressInput" prepend-inner-icon="place" ref="input" :class="$inputError('location.Latitude', validation)" v-on:listeners="slotProps.listeners" v-on:attrs="slotProps.attrs"></v-text-field>
                      </template>
                    </gmap-autocomplete>
                    <i class="fas fa-trash cursor-pointer position-absolute text-danger delete-icon" @click="resetMap" v-if="currentOrganization.location.longtitude != null || currentOrganization.location.latitude != null"></i>
                  </div>
                  <span class="error">{{ $errorMessage("location.Latitude", validation) }}</span>

                  <br />
                  <GmapMap :center="getLatLng" :zoom="7" map-type-id="terrain" style="width: 100%; height: 300px; border-radius: 8px; overflow: hidden;" ref="mapRef">
                    <GmapMarker :key="currentOrganization.location.latitude" :position="getLatLng" :clickable="true" :draggable="true" @dragend="setCenter" ref="marker" />
                  </GmapMap>
                  <span class="error">{{ $errorMessage("location.Latitude", validation) }}</span>
                </el-form-item>
                <hr />
              </template>

              <el-form-item label="Website" :class="{ error: validInput('website', validation) }">
                <el-input size="medium" v-model="currentOrganization.website">
                  <i class="fa fa-globe el-input__icon" slot="suffix"></i>
                  <template slot="prepend">https://</template>
                </el-input>
              </el-form-item>
              <el-form-item label="Facebook" :class="{ error: validInput('facebook', validation) }">
                <el-input size="medium" v-model="currentOrganization.facebook">
                  <i class="fab fa-facebook el-input__icon" slot="suffix"></i>
                  <template slot="prepend">https://www.facebook.com/</template>
                </el-input>
              </el-form-item>
              <el-form-item label="Instagram" :class="{ error: validInput('instagram', validation) }">
                <el-input size="medium" v-model="currentOrganization.instagram">
                  <i class="fab fa-instagram el-input__icon" slot="suffix"></i>
                  <template slot="prepend">https://www.instagram.com/</template>
                </el-input>
              </el-form-item>
              <el-form-item label="Linkedin" :class="{ error: validInput('linkedIn', validation) }">
                <el-input size="medium" v-model="currentOrganization.linkedIn">
                  <i class="fab fa-linkedin el-input__icon" slot="suffix"></i>
                  <template slot="prepend">https://www.linkedin.com/</template>
                </el-input>
              </el-form-item>
              <el-form-item label="Twitter" :class="{ error: validInput('twitter', validation) }">
                <el-input size="medium" v-model="currentOrganization.twitter">
                  <i class="fab fa-twitter el-input__icon" slot="suffix"></i>
                  <template slot="prepend">https://www.twitter.com/</template>
                </el-input>
              </el-form-item>
              <el-form-item label="Youtube" :class="{ error: validInput('youtube', validation) }">
                <el-input size="medium" v-model="currentOrganization.youtube">
                  <i class="fab fa-youtube el-input__icon" slot="suffix"></i>
                  <template slot="prepend">https://www.youtube.com/</template>
                </el-input>
              </el-form-item>

              <div class="d-flex justify-content-between w-100">
                <el-button :loading="loading == 'saveProfile'" type="danger" @click="deleteDialog = true">{{ $t("homeMenu.deleteOrganizationTitle") }}</el-button>
                <el-button :loading="loading == 'saveProfile'" type="primary" @click="saveProfile">{{ $t("organisation.profile.updateProfile") }}</el-button>
              </div>
              <el-dialog :visible.sync="deleteDialog" :title="currentOrganization.title != null || currentOrganization.title != undefined ? $t('homeMenu.deleteOrganizationTitle', [currentOrganization.title]) : ''" class="medium" :destroy-on-close="true" :close-on-click-modal="false" @close="closeDeleteOrganization">
                <div class="custom-modal">
                  <div class="modal-body">
                    <el-row>
                      <el-col :span="24">
                        <el-alert type="info" show-icon :closable="false">
                          {{ $t("homeMenu.organizationDelete") }}
                        </el-alert>
                      </el-col>
                      <el-col :span="24">
                        <div class="custom-form-input-container">
                          <div class="custom-label">
                            <label>
                              {{ $t("homeMenu.password") }}
                            </label>
                          </div>
                          <el-input v-model="deleteForm.password" type="password" show-password @clear="deleteForm.password = null" clearable :class="$inputError('password', deleteForm.validationErrors)"></el-input>
                          <span class="error" v-if="deleteForm.validationErrors.some(x => x.key == 'password')">{{ $errorMessage("password", deleteForm.validationErrors) }}</span>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="modal-footer mt-0" slot="footer">
                    <div class="left-buttons">
                      <el-button @click="deleteDialog = false">{{ $t("homeMenu.cancel") }}</el-button>
                    </div>
                    <div class="right-buttons">
                      <el-button type="danger" :loading="loading == 'deleteOrganization'" @click="organizationDelete">{{ $t("homeMenu.delete") }}</el-button>
                    </div>
                  </div>
                </div>
              </el-dialog>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrganisationProfile",
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.organisationProfile")
    };
  },
  data() {
    return {
      venueChanged: false,
      addressChanged: false,
      validationErrors: [],
      loading: false,
      timeout: null,
      deleteDialog: false,
      deleteOrganisation: {},
      deleteForm: {
        password: null,
        validationErrors: []
      },
      organisationForm: {
        name: null,
        about: null,
        phone: null,
        mobile: null,
        email: null,
        image: null,
        cover: null,
        address: null,
        social: {
          website: null,
          facebook: null,
          instagram: null,
          linkedin: null,
          twitter: null,
          youtube: null
        }
      }
    };
  },
  computed: {
    getLatLng() {
      if (this.currentOrganization.location.latitude == null || this.currentOrganization.location.latitude == "") {
        return {
          lat: 41.0054958,
          lng: 28.8720965
        };
      }
      return {
        lat: parseFloat(this.currentOrganization.location.latitude),
        lng: parseFloat(this.currentOrganization.location.longtitude)
      };
    },
    organizationCategories() {
      return this.$store.getters.getOrganizationCategories;
    },
    currentOrganization() {
      return this.$store.getters.getCurrentOrganization;
    },
    validation() {
      return this.$store.getters.getOrganizationValidationErrors;
    }
  },
  async created() {
    await this.$store.dispatch("getOrganizationCategories");
    var newForm = this.currentOrganization;
    if (newForm.instagram != null) {
      newForm.instagram = newForm.instagram.replaceAll("https://www.instagram.com/", "");
    }
    if (newForm.twitter != null) {
      newForm.twitter = newForm.twitter.replaceAll("https://www.twitter.com/", "");
    }
    if (newForm.linkedIn != null) {
      newForm.linkedIn = newForm.linkedIn.replaceAll("https://www.linkedin.com/", "");
    }
    if (newForm.facebook != null) {
      newForm.facebook = newForm.facebook.replaceAll("https://www.facebook.com/", "");
    }
    if (newForm.youtube != null) {
      newForm.youtube = newForm.youtube.replaceAll("https://www.youtube.com/", "");
    }
    if (newForm.website != null) {
      newForm.website = newForm.website.replaceAll("https://", "");
    }
  },
  watch: {},
  methods: {
    closeDeleteOrganization() {
      this.deleteForm = {
        password: null,
        validationErrors: []
      };
      this.deleteOrganization = {};
    },
    async organizationDelete() {
      this.loading = "deleteOrganization";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.currentOrganization.id,
          password: this.deleteForm.password
        };
        var res = await this.$store.dispatch("organizationDelete", payload);
        this.deleteForm.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.deleteDialog = false;
          this.deleteForm = {
            password: null,
            validationErrors: []
          };
          this.deleteOrganization = {};
          await this.$store.dispatch("getOrganizationList");
          if (this.$route.name != "myevents") {
            this.$router.push({ name: "myevents" }).catch(e => {});
          }
        }
        this.loading = false;
      }, 500);
    },
    resetMap() {
      this.currentOrganization.location.latitude = null;
      this.currentOrganization.location.longtitude = null;
    },
    setCenter(event) {
      this.currentOrganization.location.latitude = event.latLng.lat();
      this.currentOrganization.location.longtitude = event.latLng.lng();
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: this.currentOrganization.location.latitude,
          lng: this.currentOrganization.location.longtitude
        });
      });

      this.$geocoder.send(
        {
          lat: this.currentOrganization.location.latitude,
          lng: this.currentOrganization.location.longtitude
        },
        response => {
          if (response.results.length != 0) {
            document.getElementsByClassName("introInput")[0].value = response.results[0].formatted_address;
            if (this.addressChanged == false) {
              this.currentOrganization.location.address = response.results[0].formatted_address;
            }
          }
        }
      );
    },
    placeChanged(place) {
      this.currentOrganization.location.venue = place.name;
      this.currentOrganization.location.address = place.formatted_address;
      this.currentOrganization.location.latitude = place.geometry.location.lat();
      this.currentOrganization.location.longtitude = place.geometry.location.lng();
      this.$refs.mapRef.$mapPromise.then(map => {
        map.panTo({
          lat: this.currentOrganization.location.latitude,
          lng: this.currentOrganization.location.longtitude
        });
      });
    },
    saveProfile() {
      this.loading = "saveProfile";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var newForm = JSON.parse(JSON.stringify(this.currentOrganization));
        this.$nextTick(() => {
          if (newForm.instagram != null) {
            newForm.instagram = "https://www.instagram.com/" + newForm.instagram;
          }
          if (newForm.twitter != null) {
            newForm.twitter = "https://www.twitter.com/" + newForm.twitter;
          }
          if (newForm.linkedIn != null) {
            newForm.linkedIn = "https://www.linkedin.com/" + newForm.linkedIn;
          }
          if (newForm.facebook != null) {
            newForm.facebook = "https://www.facebook.com/" + newForm.facebook;
          }
          if (newForm.youtube != null) {
            newForm.youtube = "https://www.youtube.com/" + newForm.youtube;
          }
          if (newForm.website != null) {
            newForm.website = "https://" + newForm.website;
          }
        });

        this.$nextTick(async () => {
          var res = await this.$store.dispatch("updateOrganizationProfile", newForm);
          if (this.currentOrganization.location.venue != "" && this.currentOrganization.location.venue != null) {
            this.venueChanged = true;
          }

          if (this.currentOrganization.location.address != "" && this.currentOrganization.location.address != null) {
            this.addressChanged = true;
          }
        });
        this.loading = false;
      }, 500);
    },
    coverSuccess(response) {
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.currentOrganization.cover = response.data.item.url;
      }
    },
    logoSuccess(response) {
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.currentOrganization.image = response.data.item.url;
      }
    }
  }
};
</script>

<style lang="less">
.completed-area {
  .delete-icon {
    right: 1rem;
    top: calc(~"50% - 14px");
  }
}
.introInput {
  background-color: #fbfbfb;
  border-radius: 8px;
  border: 0.5px solid #d6d9d9;
  color: #505763;
  font-size: 14px;
  font-weight: 400;
  height: 42px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  position: relative;
  .delete-icon {
    right: 0;
    top: 0;
  }
  &:focus {
    border-color: #03658c;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    outline: 0;
  }

  &:focus-visible {
    outline: 0;
  }

  &:hover {
    border-color: #c0c4cc;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:focus {
      border-color: #03658c;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      outline: 0;
    }
  }
}

#organisation-profile {
  .org-profile-container {
    width: calc(~"100% - 110px");
    margin: 0 auto;

    hr {
      border-top: 1px solid #f1f3f6 !important;
    }

    .el-form-item__label {
      text-align: left;
    }

    .progress-float {
      float: right;
      margin-left: unset !important;
    }
  }

  .profile-cover {
    margin: 0px 0px 20px 0px;
    position: relative;

    a {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-color: #292f3b65;
      opacity: 0;
      z-index: 1;
      transition: all 0.5s ease;

      & > .avatar-uploader {
        margin-top: 15%;
      }

      &:hover {
        opacity: 1;
      }
    }

    .profile-cover-img {
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: cover;
      aspect-ratio: 11.2/5;
      width: 100%;
      height: auto;
    }
  }

  .custom-profile-bar {
    padding: 0px 28px;
    padding-bottom: 20px;
    margin-bottom: 20px !important;
    margin-top: -42px !important;
    z-index: 2;
    border-bottom: 1px solid #f1f3f6;
  }

  .profile-thumb {
    position: relative;

    a {
      border-radius: 16px;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background-color: #292f3b65;
      opacity: 0;
      transition: all 0.5s ease;
      & > .avatar-uploader {
        margin-top: 25%;
      }

      &:hover {
        opacity: 1;
      }
    }

    img {
      border: 3px solid #fff;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);
      width: 120px;
      height: 120px;
      border-radius: 16px;
      background: rgb(236, 236, 236);
      cursor: default;
    }
  }

  // should be fully refactored
  a {
    & > .avatar-uploader {
      margin-top: 15%;
      text-align: center;
      & > .el-upload {
        border: none;
        width: min-content !important;
      }
      & > .el-upload__tip {
        color: white !important;
      }
    }
  }

  .custom-media-text {
    margin-top: 16px;
    color: #292f3b !important;
  }

  .custom-media-text h1 {
    font-weight: 700;
    font-size: 22px;
  }

  .custom-media-text span {
    color: #505763;
    font-size: 14px;
    font-weight: 500;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    display: flex !important;
  }
}
.cover-upload-button {
  &.image {
    flex-direction: column;
    gap: 5px;
  }
  background-color: #292f3bbb !important;
  display: flex;
  gap: 5px;
  align-items: center;
  span {
    border: none !important;
    background-color: unset !important;
  }
}
.error {
  input {
    border-color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganisationProfile.vue